import { colors, gridSize } from '@atlaskit/theme';
import React from 'react';
import styled from 'styled-components';

const gridSizeResult = gridSize();

const Skeleton = styled.div`
  margin-right: 4px;
  padding: 6px 4px;
  div {
    background-color: ${colors.N20};
    border-radius: 50%;
    width: ${gridSizeResult * 3}px;
    height: ${gridSizeResult * 3}px;
  }
`;

const SkeletonNavItem = () => {
  return (
    <Skeleton>
      <div />
    </Skeleton>
  );
};

export default SkeletonNavItem;
